import { buildApiUrl } from './apiBase.js';
import { notifyUnauthorized } from './authController.js';

/**
 * 管理 API 共通 fetch
 */
export async function adminApiFetch(path, options = {}) {
  const response = await fetch(buildApiUrl(path), {
    credentials: 'include',
    ...options
  });

  const contentType = response.headers.get('content-type') || '';
  const data = contentType.includes('application/json')
    ? await response.json().catch(() => ({}))
    : null;

  if (!response.ok) {
    if (response.status === 401) {
      notifyUnauthorized();
    }
    const err = new Error(data?.message || `API エラー (${response.status})`);
    err.status = response.status;
    err.code = data?.error || null;
    throw err;
  }

  if (!contentType.includes('application/json')) {
    const err = new Error(`API が不正な応答を返しました (${response.status})。バックエンドを再起動してください。`);
    err.status = response.status;
    throw err;
  }

  return data;
}
